<template>
  <div class="usage-chip">
    <span class="usage-chip__indicator" aria-hidden="true" />
    <p class="usage-chip__label">
      <span class="usage-chip__count">20,000+</span> spaces scanned in last 90
      days
    </p>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.usage-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 1.5rem;
  padding: 0.5rem 1.125rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.08);
  &__indicator {
    flex-shrink: 0;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(0, 255, 18, 1);
    box-shadow: 0 0 8px rgba(0, 255, 18, 0.65);
    animation: usage-pulse 2.4s ease-in-out infinite;
  }
  &__label {
    margin: 0;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.35;
    letter-spacing: 0.01em;
    color: rgba(255, 255, 255, 0.82);
    text-wrap: balance;
  }
  &__count {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.98);
  }
  @include respond-below(sm) {
    margin-bottom: 1.25rem;
    padding: 0.45rem 0.9rem;
    gap: 0.5rem;
    max-width: 92%;
    &__label {
      font-size: 0.78rem;
      line-height: 1.4;
    }
    &__indicator {
      width: 6px;
      height: 6px;
    }
  }
}
</style>
